
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.92 17.84a16.53 16.53 0 01-4.7 1.29 8.204 8.204 0 003.6-4.53c-1.58.94-3.33 1.62-5.2 1.99a8.194 8.194 0 00-14.17 5.6c0 .64.07 1.27.21 1.87-6.81-.34-12.84-3.6-16.88-8.56a8.211 8.211 0 002.53 10.94c-1.34-.04-2.6-.41-3.71-1.02v.1c0 3.97 2.82 7.28 6.57 8.03a8.101 8.101 0 01-3.7.14 8.211 8.211 0 007.65 5.69c-2.8 2.2-6.33 3.51-10.17 3.51-.66 0-1.31-.04-1.95-.11a23.2 23.2 0 0012.55 3.68c15.06 0 23.3-12.48 23.3-23.3 0-.35 0-.71-.02-1.06 1.6-1.15 2.99-2.6 4.09-4.24v-.02z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    